import { UserView } from './user/user-view';
import { RouterModule, Routes } from "@angular/router";
import { HomeComponent } from "./home/home.component";
import { NgModule } from "@angular/core";
import { UserTabsComponent } from "./user/user-tabs.component";
import { UserUpdateComponent } from "./user/user-update.component";
import { RefreshType, ModalSize, ColumnType, FormType, CanDeactivateGuard, OrgJedView, CanActivateFalseGuard, Action, ActionView, RequestType } from "yt-ng-framework";
import { User } from "./user/user";
import { AdminComponent } from "./admin.component";
import { LookupsRoutes } from "../lookups/routes";
import { Language } from "../lookups/language/Language";
import { LanguageComponent } from "../lookups/language/language.component";
import { LanguageModalUpdateComponent } from "../lookups/language/language-modal-update.component";
import { UserroleComponent } from "./userrole/userrole.component";
import { UserroleModalUpdateComponent } from "./userrole/userrole-modal-update.component";
import { UserRole } from "./userrole/userrole";
import { CompanyTabsComponent } from "./company/company-tabs.component";
import { CompanyUpdateComponent } from "./company/company-update.component";
import { MestoComponent } from "../lookups/mesto/mesto.component";
import { Mesto } from "../lookups/mesto/mesto";
import { MestoModalUpdateComponent } from "../lookups/mesto/mesto-modal-update.component";
import { Company } from "./company/company";
import { CompanyView } from "./company/company-view";
import { CompanyEmail } from "./company/company-email/company-email";
import { CompanyEmailView } from "./company/company-email/company-email-view";
import { CompanyEmailModalUpdateComponent } from "./company/company-email/company-email-modal-update.component";
import { CompanyTelefon } from "./company/company-telefon/company-telefon";
import { CompanyTelefonView } from "./company/company-telefon/company-telefon-view";
import { CompanyTelefonModalUpdateComponent } from "./company/company-telefon/company-telefon-modal-update.component";
import { CompanyZrc } from "./company/company-zrc/company-zrc";
import { CompanyZrcView } from "./company/company-zrc/company-zrc-view";
import { CompanyZrcModalUpdateComponent } from "./company/company-zrc/company-zrc-modal-update.component";
import { SvojinaComponent } from "../lookups/svojina/svojina.component";
import { Svojina } from "../lookups/svojina/svojina";
import { SvojinaModalUpdateComponent } from "../lookups/svojina/svojina-modal-update.component";
import { VrstaTelefonaComponent } from "../lookups/vrsta-telefona/vrsta-telefona.component";
import { VrstaTelefona } from "../lookups/vrsta-telefona/vrsta-telefona";
import { VrstaTelefonaModalUpdateComponent } from "../lookups/vrsta-telefona/vrsta-telefona-modal-update.component";
import { BankaComponent } from "../lookups/banka/banka.component";
import { Banka } from "../lookups/banka/banka";
import { BankaView } from "../lookups/banka/banka-view";
import { BankaModalUpdateComponent } from "../lookups/banka/banka-modal-update.component";
import { MestoView } from "../lookups/mesto/mesto-view";
import { OrgJed } from '../lookups/orgjed/orgjed';
import { UserProvajder } from './orgjeddefgini/userprovajder/userprovajder';
import { UserProvajderView } from './orgjeddefgini/userprovajder/userprovajder-view';
import { Provajder } from './orgjeddefgini/userprovajder/provajder/provajder';
import { OrgjeddefginiTabsComponent } from './orgjeddefgini/orgjeddefgini-tabs.component';
import { ProvajderComponent } from './orgjeddefgini/userprovajder/provajder/provajder.component';
import { ProvajderModalUpdateComponent } from './orgjeddefgini/userprovajder/provajder/provajder-modal-update.component';
import { PodesavanjeAkcijaComponent } from './podesavanje-akcija/podesavanje-akcija.component';
import { AkcijaUpdateModalComponent } from './podesavanje-akcija/akcija/akcija-update-modal.component';
import { InstrukcijaPlacanja } from './company/company-zrc-new/instrukcija-placanja';
import { InstrukcijaPlacanjaView } from './company/company-zrc-new/instrukcija-placanja-view';
import { CompanyZrcNewTabsComponent } from './company/company-zrc-new/company-zrc-new-tabs.component';
import { InstrukcijaPlacanjaModalUpdateComponent } from './company/company-zrc-new/instrukcija-placanja-modal-update.component';
import { FirmaObjekat } from './company/firma-objekat/firma-objekat';
import { FirmaObjekatView } from './company/firma-objekat/firma-objekat-view';
import { FirmaObjekatComponent } from './company/firma-objekat/firma-objekat.component';


let childrenRoutes: Routes = [
    {
        path: 'home',
        component: HomeComponent
    },
    {
        path: 'podesavanjekljuceva',
        component: OrgjeddefginiTabsComponent,
        pathMatch: 'full',
        canDeactivate: [ CanDeactivateGuard ],
        data: {
            mainList: {
                label: 'TABLE.PODESAVANJEKLJUCEVA.PLURAL',
                defaultListConfig: { showToolbar: false},
                modelName: 'orgjed',
                getName: 'getRootByUser',
                userRightsModelName: 'podesavanjekljuceva',
                getParameters: [],
                modelClass: OrgJed,
                shortModelClass: OrgJedView,
                parentProperty:'',
                tableColumns: [
                    { name: 'Naziv', label: 'ORGJED.NAZIV.SINGULAR', visible: true, canHide: false },
                    { name: 'FirmaNaziv', label: 'ORGJED.FIRMANAZIV.SINGULAR', visible: true, canHide: false},
                ],
                sortBy: 'DatumPrijema',
                sortReverse: false,
                enableEdit: false,
                enableDelete: false,
                formType: FormType.Reactive,
                closeAfterSave: false,
                detailList: [
                    {
                        label: 'TABLE.PODESAVANJEKLJUCEVASTAVKE.PLURAL',
                        modelName: 'userprovajder',
                        getName: 'getByOrgJedID',
                        getParamerters:[],
                        modelClass: UserProvajder,
                        shortModelClass: UserProvajderView,
                        tableColumns: [
                            { name: 'Korisnik', label: 'USERPROVAJDER.USER.SINGULAR', visible: true, canHide: false, width: '20%' },
                            { name: 'MiniBizUsername', label: 'USERPROVAJDER.MINIBIZUSERNAME.SINGULAR', visible: true, canHide: false, width: '20%' },
                            { name: 'Provajder', label: 'USERPROVAJDER.PROVAJDER.SINGULAR', visible: true, canHide: false, width: '10%' },
                            { name: 'EOtprProvajder', label: 'USERPROVAJDER.EOTPRPROVAJDER.SINGULAR', visible: true, canHide: false, width: '10%' },
                            { name: 'Firma', label: 'USERPROVAJDER.FIRMA.SINGULAR', visible: true, canHide: false, width: '20%' },
                            { name: 'IsActive', label: 'USERPROVAJDER.ISACTIVE.SINGULAR', visible: true, canHide: false, type:ColumnType.Boolean, width: '10%', aligment: 'center', },
                        ],
                        sortBy: 'isActive',
                        sortReverse: false,
                        enableEdit: true,
                        enableDelete: true,
                        parentProperty: 'OrgJedId',
                        updateComponent: '',
                        showOnFirstPage: false,
                        formType: FormType.Reactive,
                        refreshType: RefreshType.Reload,
                        defaultPropertyName: 'Korisnik'
                        
                    },
                    {
                        modelName: 'User',
                        userRightsModelName : 'user',
                        getName: 'getByOrgJedID',
                        getParamerters:[],
                        modelClass: User,
                        shortModelClass: UserView,
                        tableColumns: [
            
                              { name: 'FirstName', label: 'USER.IME.SINGULAR', visible: true, canHide: true }
                            , { name: 'LastName', label: 'USER.PREZIME.SINGULAR', visible: true, canHide: true}
                            , { name: 'IPAddress', label: 'USER.IPADDRESS.SINGULAR' }

                        ],
                        sortBy: 'FirstName',
                        sortReverse: false,
                        enableEdit: true,
                        enableDelete: true,
                        parentProperty: 'OrgJedId',
                        updateComponent: '',
                        showOnFirstPage: false,
                        formType: FormType.Reactive,
                        refreshType: RefreshType.Reload,
                        defaultPropertyName: 'FirstName'
                    }

                ],

            },
            mainTitle: 'Organizacione jedinice',
            updateComponent: '',
            refreshType: RefreshType.Reload,
            loadOnInit: true,
            breadcrumbLabel: 'PODESAVANJEKLJUCEVA.PLURAL'
        }
    },
    {
        path: 'provajder',
        component: ProvajderComponent,
        pathMatch: 'full',
        canDeactivate: [ CanDeactivateGuard ],
        data: {
            mainList: {
                modelName: 'provajder',
                getName: 'get',
                getParameters: [],
                modelClass: Provajder,
                parentProperty:'',
                tableColumns: [
                    { name: 'Naziv', label: 'PROVAJDER.NAZIV.SINGULAR', visible: true, canHide: false },
                    { name: 'Url', label: 'PROVAJDER.SEFURL.SINGULAR', visible: true, canHide: false },
                    { name: 'EotpremnicaUrl', label: 'PROVAJDER.EOTPREMNICAURL.SINGULAR', visible: true, canHide: false }
                    // { name: 'GenericName', label: 'PROVAJDER.GENERICNAME.SINGULAR', visible: true, canHide: false },
                    // { name: 'IsActive', label: 'PROVAJDER.ISACTIVE.SINGULAR', visible: true, canHide: false },
                ],
                sortBy: 'Naziv',
                sortReverse: false,
                enableEdit: true,
                enableDelete: true,
                formType: FormType.Reactive,
                closeAfterSave: false,
            },
            mainTitle: 'provajderi',
            updateComponent: ProvajderModalUpdateComponent,
            refreshType: RefreshType.Reload,
            loadOnInit: true,
            breadcrumbLabel: 'PROVAJDERI.PLURAL'
        }
    },
    {
        path: 'user',
        component: UserTabsComponent,
        canDeactivate: [ CanDeactivateGuard ],
        pathMatch: 'full',
        data: {
            mainList: {
                modelName: 'User',
                userRightsModelName : 'user',
                getName: 'get',
                getParameters: [],
                modelClass: User,
                shortModelClass: UserView,
                parentProperty: '',
                tableColumns: [
                    { name: 'Email', label: 'USER.EMAIL.SINGULAR', visible: true, canHide: false , width: '20%'}
                    , { name: 'FirstName', label: 'USER.IME.SINGULAR', visible: true, canHide: true ,width: '10%' }
                    , { name: 'LastName', label: 'USER.PREZIME.SINGULAR', visible: true, canHide: true,width: '10%' }
                    , { name: 'CompanyName', label: 'USER.FIRMA.SINGULAR' ,width: '15%' }
                    , { name: 'Phone', label: 'USER.PHONE.SINGULAR', visible: true, canHide: true,width: '10%' }
                    , { name: 'RoleName', label: 'USER.KORISNICKAROLA.SINGULAR', visible: true, canHide: true ,width: '10%' }
                    , { name: 'RegistrationDate', label: 'USER.REGISTRATIONDATE.SINGULAR', visible: true, canHide: true, type: 'datetime', format: 'dd.MM.yyyy',width: '10%'  }
                    , { name: 'LastLoginDate', label: 'USER.LASTLOGINDATE.SINGULAR', visible: true, canHide: true, type: 'datetime', format: 'dd.MM.yyyy',width: '10%'}
                    , { name: 'is_active', label: 'USER.ISACTIVE.SINGULAR', visible: true, canHide: false, type:ColumnType.Boolean,width: '5%' }
                ],
                sortBy: 'Email',
                sortReverse: false,
                enableEdit: true,
                enableDelete: true,
                formType: FormType.Reactive
            },
            mainTitle: 'Korisnici',
            updateComponent: UserUpdateComponent,
            refreshType: RefreshType.NoReload,
            loadOnInit: true,
            breadcrumbLabel: 'USER.PLURAL'
        }
    }
    // {
    //     path: 'user-napomena',
    //     component: UserNapomenaComponent,
    //     pathMatch: 'full',
    //     canDeactivate: [ CanDeactivateGuard ],
    //     data: {
    //         mainList: {
    //             modelName: 'user-napomena',
    //             getName: 'get',
    //             getParameters: [],
    //             modelClass: Provajder,
    //             parentProperty:'',
    //             tableColumns: [
    //                 { name: 'Napomena', label: 'USER.NAPOMENA.SINGULAR', visible: true, canHide: false }
    //                 // { name: 'GenericName', label: 'PROVAJDER.GENERICNAME.SINGULAR', visible: true, canHide: false },
    //                 // { name: 'IsActive', label: 'PROVAJDER.ISACTIVE.SINGULAR', visible: true, canHide: false },
    //             ],
    //             sortBy: 'Napomena',
    //             sortReverse: false,
    //             enableEdit: true,
    //             enableDelete: true,
    //             formType: FormType.Reactive,
    //             closeAfterSave: false,
    //         },
    //         mainTitle: 'napomena',
    //         updateComponent: UserNapomenaModalUpdateComponent,
    //         refreshType: RefreshType.Reload,
    //         loadOnInit: true,
    //         breadcrumbLabel: 'USERNAPOMENA.PLURAL'
    //     }
    // }
    ,{
        path: 'language',
        component: LanguageComponent,
        pathMatch: 'full',
        data: {
            mainList: {
                modelName: 'language',
                getName: 'get',
                getParameters: [],
                modelClass: Language,
                parentProperty: '',
                tableColumns: [
                    { name: 'Name', label: 'Naziv', visible: true, canHide: false}
                ],
                sortBy: 'Name',
                sortReverse: false,
                enableEdit: true,
                enableDelete: true,
                formType: 'reactive',
            },
            mainTitle: 'Jezik',
            updateComponent: LanguageModalUpdateComponent,
            modalSize: ModalSize.Md,
            refreshType: RefreshType.Reload,
            loadOnInit: true
        }
    }
    ,{
        path: 'userrole',
        component: UserroleComponent,
        pathMatch: 'full',
        data: {
            mainList: {
                modelName: 'UserRole',
                getName: 'get',
                getParameters: [],
                modelClass: UserRole,
                parentProperty: '',
                tableColumns: [
                    { name: 'Name', label: 'Naziv', visible: true, canHide: false}
                ],
                sortBy: 'Name',
                sortReverse: false,
                enableEdit: true,
                enableDelete: true
            },
            mainTitle: 'Rola',
            updateComponent: UserroleModalUpdateComponent,
            modalSize: ModalSize.Md,
            refreshType: RefreshType.Reload,
            loadOnInit: true
        }
    }
    ,{
        path: 'firma',
        component: CompanyTabsComponent,
        canDeactivate: [ CanDeactivateGuard ],
        pathMatch: 'full',
        data: {
            mainList: {
                label: 'TABLE.FIRME.PLURAL',
                modelName: 'Firma',
                userRightsModelName : 'firma',
                getName: 'get',
                getParameters: [],
                modelClass: Company,
                shortModelClass: CompanyView,
                parentProperty: '',
                tableColumns: [
                      { name: 'SNaziv', label: 'FIRMA.SNAZIV.SINGULAR', visible: true, canHide: false }
                    , { name: 'Pib', label: 'FIRMA.PIB.SINGULAR', visible: true, canHide: true }
                    , { name: 'MaticniBroj', label: 'FIRMA.MATICNIBROJ.SINGULAR', visible: true, canHide: true }
                    , { name: 'Mesto', label: 'FIRMA.MESTO.SINGULAR', visible: true, canHide: true}                            
                ],
                sortBy: 'SNaziv',
                sortReverse: false,
                enableEdit: true,
                enableDelete: true,
                formType: 'reactive',
                detailList: [
                    {
                     label: 'TABLE.FIRMESTAVKE.PLURAL',
                      modelName: 'FirmaEmail',
                      getName: 'getByFirmaID',
                      getParameters: [],
                      modelClass: CompanyEmail,
                      shortModelClass: CompanyEmailView,
                      tableColumns: [
                        { name: 'Opis', label: 'FIRMAEMAIL.OPIS.SINGULAR', visible: true, width: '25%'}
                        , { name: 'Email', label: 'FIRMAEMAIL.NAZIV.SINGULAR', visible: true, width: '25%'}
                        , { name: 'Glavni', label: 'FIRMAEMAIL.GLAVNI.SINGULAR', visible: true, type: ColumnType.Boolean, width: '25%', aligment: 'center'}
                        , { name: 'Svojina', label: 'FIRMAEMAIL.SVOJINA.SINGULAR', visible: true, width: '25%'}
                      ],
                      sortBy: 'Email',
                      sortReverse: false,
                      enableEdit: false,
                      enableDelete: false,
                      parentProperty: 'FirmaID',
                      updateComponent: CompanyEmailModalUpdateComponent,
                      formType: 'reactive',
                      showOnFirstPage: false,
                      refreshType: RefreshType.Reload,
                      defaultPropertyName: 'Email'

                    }
                    ,{
                        modelName: 'FirmaTelefon',
                        getName: 'getByFirmaID',
                        getParameters: [],
                        modelClass: CompanyTelefon,
                        shortModelClass: CompanyTelefonView,
                        tableColumns: [
                          { name: 'Opis', label: 'FIRMATELEFON.OPIS.SINGULAR', visible: true, width: '15%'}
                          , { name: 'Broj', label: 'FIRMATELEFON.BROJ.SINGULAR', visible: true, width: '15%'}
                          , { name: 'VrstaTelefona', label: 'FIRMATELEFON.VRSTATELEFONA.SINGULAR', visible: true, width: '15%'}
                          , { name: 'Glavni', label: 'FIRMATELEFON.GLAVNI.SINGULAR', visible: true, type: ColumnType.Boolean, width: '15%', aligment: 'center'}
                          , { name: 'Lokal', label: 'FIRMATELEFON.LOKAL.SINGULAR', visible: true, width: '15%'}
                          , { name: 'Svojina', label: 'FIRMATELEFON.SVOJINA.SINGULAR', visible: true, width: '15%'}
                        ],
                        sortBy: 'Broj',
                        sortReverse: false,
                        enableEdit: false,
                        enableDelete: false,
                        parentProperty: 'FirmaID',
                        updateComponent: CompanyTelefonModalUpdateComponent,
                        formType: 'reactive',
                        refreshType: RefreshType.Reload,
                        defaultPropertyName: 'Broj'
                      }
                      ,{
                        // data:{
                        //     mainList:{
                        //         modelName: 'FirmaZrc',
                        //         getName: 'getByFirmaID',
                        //         getParameters: [],
                        //         modelClass: CompanyZrc,
                        //         shortModelClass: CompanyZrcView,
                        //         tableColumns: [
                        //             { name: 'Zrc', label: 'FIRMAZRC.SINGULAR', visible:true,  width: '15%'}
                        //             ,{ name: 'Glavni', label: 'FIRMAZRC.GLAVNI.SINGULAR', visible:true, type:ColumnType.Boolean, width: '4%'}  
                        //             ,{ name: 'Devizni', label: 'FIRMAZRC.DEVIZNI.SINGULAR', visible:true, type:ColumnType.Boolean, width: '4%'}  
                        //             ,{ name: 'Banka', label: 'FIRMAZRC.BANKA.SINGULAR', visible:true}                       
                        //         ],
                        //         sortBy: 'Zrc',
                        //         sortReverse: false,
                        //         enableEdit: false,
                        //         enableDelete: false,
                        //         parentProperty: 'FirmaID',
                        //         updateComponent: CompanyZrcModalUpdateComponent,
                        //         formType: 'reactive',
                        //         refreshType: RefreshType.Reload
                        //     },
                        //     detailList:[
                        //         {
                        //             modelName: 'InstrukcijaPlacanja',
                        //             getName: 'getByFirmaZrcID',
                        //             getParameters: [],
                        //             modelClass: InstrukcijaPlacanja,
                        //             shortModelClass: InstrukcijaPlacanjaView,
                        //             tableColumns: [
                        //                 {name: 'Intermediary', label: 'INSTRUKCIJAPLACANJA.INTERMEDIARY.SINGULAR', visible: true}
                        //             ],
                        //             sortBy: 'ID',
                        //             sortReverse: false,
                        //             enableEdit: false,
                        //             enableDelete: false,
                        //             parentProperty: 'FirmaZrcID',
                        //             // update?Component: ,
                        //             formType: 'reactive',
                        //             showOnFirstPage: true
                        //         }
                        //     ]
                        // }
                        modelName: 'FirmaZrc',
                        getName: 'getByFirmaID',
                        getParameters: [],
                        modelClass: CompanyZrc,
                        shortModelClass: CompanyZrcView,
                        tableColumns: [
                            { name: 'Zrc', label: 'FIRMAZRC.SINGULAR', visible:true,  width: '15%'}
                            ,{ name: 'Glavni', label: 'FIRMAZRC.GLAVNI.SINGULAR', visible:true, type:ColumnType.Boolean, width: '4%'}  
                            ,{ name: 'Devizni', label: 'FIRMAZRC.DEVIZNI.SINGULAR', visible:true, type:ColumnType.Boolean, width: '4%'}  
                            ,{ name: 'Banka', label: 'FIRMAZRC.BANKA.SINGULAR', visible:true}                       
                        ],
                        sortBy: 'Zrc',
                        sortReverse: false,
                        enableEdit: false,
                        enableDelete: false,
                        parentProperty: 'FirmaID',
                        updateComponent: CompanyZrcModalUpdateComponent,
                        formType: 'reactive',
                        refreshType: RefreshType.Reload
                      }
                  ]
            },
            mainTitle: 'Firme',
            updateComponent: CompanyUpdateComponent,
            refreshType: RefreshType.NoReload,
            loadOnInit: true,
            breadcrumbLabel: 'FIRMA.PLURAL'
        }
    }
    , {
        path: 'mesto',
        component: MestoComponent,
        pathMatch: 'full',
        data: {
            mainList: {
                modelName: 'mesto',
                getName: 'get',
                getParameters: [],
                modelClass: Mesto,
                shortModelClass: MestoView,
                parentProperty:'',
                tableColumns: [
                    { name: 'PostBroj', label: 'Poštanski broj', visible: true, canHide: false },
                    { name: 'Naziv', label: 'Naziv', visible: true, canHide: false},
                    { name: 'Opstina.Naziv', label: 'Opština', visible: true, canHide: false}                      
                ],
                sortBy: 'Naziv',
                sortReverse: false,
                enableEdit: true,
                enableDelete: true
            },
            mainTitle: 'Mesta',
            updateComponent: MestoModalUpdateComponent ,
            modalSize: ModalSize.Md,
            refreshType: RefreshType.NoReload,
            loadOnInit: true
        }
    }
    , {
        path: 'svojina',
        component: SvojinaComponent,
        pathMatch: 'full',
        data: {
            mainList: {
                modelName: 'svojina',
                getName: 'get',
                getParameters: [],
                modelClass: Svojina,
                parentProperty:'',
                tableColumns: [
                    { name: 'Naziv', label: 'SVOJINA.NAZIV.SINGULAR', visible: true, canHide: false }                               
                ],
                sortBy: 'Naziv',
                sortReverse: false,
                enableEdit: true,
                enableDelete: true,
                formType: FormType.Reactive
            },
            mainTitle: 'Svojina',
            updateComponent: SvojinaModalUpdateComponent ,
            modalSize: ModalSize.Md,
            refreshType: RefreshType.NoReload,
            loadOnInit: true,
            breadcrumbLabel: 'SVOJINA.SINGULAR'
        }
    }
    , {
        path: 'vrstatelefona',
        component: VrstaTelefonaComponent,
        pathMatch: 'full',
        data: {
            mainList: {
                modelName: 'vrstatelefona',
                getName: 'get',
                getParameters: [],
                modelClass: VrstaTelefona,
                parentProperty: '',
                tableColumns: [
                    { name: 'Naziv', label: 'VRSTATELEFONA.NAZIV.SINGULAR', visible:true}                        
                ],
                sortBy: 'Naziv',
                sortReverse: true,
                enableEdit: true,
                enableDelete: true, 
                formType: FormType.Reactive
                },          
            mainTitle: 'Vrsta telefona',
            updateComponent: VrstaTelefonaModalUpdateComponent,
            modalSize: ModalSize.Md,
            refreshType: RefreshType.NoReload,
            loadOnInit: true,
            breadcrumbLabel: 'VRSTATELEFONA.SINGULAR'
        }
    }    
    ,{
        path: 'banka',
        component: BankaComponent,
        pathMatch: 'full',
        data: {
            mainList: {
                modelName: 'banka',
                getName: 'get',
                getParameters: [],
                modelClass: Banka,
                shortModelClass: BankaView,
                parentProperty: '',
                tableColumns: [
                    { name: 'Sifra', label: 'BANKA.SIFRA.SINGULAR', visible: true, canHide: false}
                    ,{ name: 'Naziv', label: 'BANKA.NAZIV.SINGULAR', visible: true, canHide: false}
                    ,{ name: 'Adresa', label: 'BANKA.ADRESA.SINGULAR', visible: true, canHide: true}
                    ,{ name: 'Mesto', label: 'BANKA.MESTO.SINGULAR', visible: true, canHide: true}
                ],
                sortBy: 'Naziv',
                sortReverse: false,
                enableEdit: true,
                enableDelete: true,
                formType: FormType.Reactive
            },
            mainTitle: 'Banka',
            updateComponent: BankaModalUpdateComponent,
            modalSize: ModalSize.Md,
            refreshType: RefreshType.NoReload ,
            loadOnInit: true,
            breadcrumbLabel: 'BANKA.SINGULAR'
        }
    },
    {
        path: 'action',
        component: PodesavanjeAkcijaComponent,
        pathMatch: 'full',
        data: {
            mainList: {
                showCheckBoxes: false, 
                modelName: 'action',
                getName: 'get',
                getParameters: [],
                modelClass: Action,
                shortModelClass: ActionView,
                parentProperty:'',
                tableColumns: [
                    { name: 'Model', label: 'ACTION.MODEL.SINGULAR', visible: true, canHide: false },
                    { name: 'Naziv', label: 'ACTION.NAZIV.SINGULAR', visible: true, canHide: false },
                    { name: 'DefaultValue', label: 'ACTION.DEFAULTVALUE.SINGULAR', visible: true, canHide: false, type:ColumnType.Boolean },                   
                ],
                sortBy: 'Model',
                sortReverse: false,
                enableEdit: true,
                enableDelete: true,
                formType:FormType.Reactive
            },
            mainTitle: 'Mesta',
            updateComponent: AkcijaUpdateModalComponent ,
            modalSize: ModalSize.Xl,
            refreshType: RefreshType.NoReload,
            loadOnInit: true,
            breadcrumbLabel: 'ACTION.PLURAL'
        }
    }, {
        path: 'firma-zrc',
        component: CompanyZrcNewTabsComponent,
        pathMatch: 'full',
        canDeactivate: [CanDeactivateGuard],
        data: {
            mainList: {    
                // DefaultListButtonsConfig:{
                //     LockButtonConfig: {
                //         Visible: false
                //     }
                // },
                modelName: 'FirmaZrc',
                getName: 'getByFirmaID',
                getParameters: [],
                modelClass: CompanyZrc,
                shortModelClass: CompanyZrcView,
                tableColumns: [
                    { name: 'Zrc', label: 'FIRMAZRC.SINGULAR', visible:true,  width: '30%'}
                  , { name: 'Glavni', label: 'FIRMAZRC.GLAVNI.SINGULAR', visible: true, type: ColumnType.Boolean, width: '15%', aligment: 'center'}
                  , { name: 'Devizni', label: 'FIRMAZRC.DEVIZNI.SINGULAR', visible: true, type: ColumnType.Boolean, width: '15%', aligment: 'center'}
                    ,{ name: 'Banka', label: 'FIRMAZRC.BANKA.SINGULAR', visible:true, width: '40%'}                       
                ],
                sortBy: 'Zrc',
                sortReverse: false,
                enableEdit: false,
                enableDelete: false,
                parentProperty: 'FirmaID',
                updateComponent: null,
                formType: 'reactive',
                // refreshType: RefreshType.Reload,
                closeAfterSave: false,
                defaultPropertyName: 'Zrc',
                detailList: [
                    {
                        modelName: 'InstrukcijaPlacanja',
                        getName: 'getByFirmaZrcID',
                        getParameters: [],
                        modelClass: InstrukcijaPlacanja,
                        // shortModelClass: InstrukcijaPlacanja,
                        tableColumns: [
                            {name: 'Intermediary', label: 'INSTRUKCIJAPLACANJA.INTERMEDIARY.SINGULAR', visible: true}
                        ],
                        sortBy: 'ID',
                        sortReverse: false,
                        enableEdit: false,
                        enableDelete: false,
                        parentProperty: 'FirmaZrcID',
                        updateComponent: InstrukcijaPlacanjaModalUpdateComponent,
                        formType: 'reactive',
                        showOnFirstPage: true,
                        defaultPropertyName: 'Intermediary'
                        // formControlDataName: 'fak/racunstavka',
                    }                    

                ],
                // formControlDataName: 'fak/racun',
                // defaultListFilterComponent: FilterWithKomitentComponent,
                requestType: RequestType.POST
            },
            //detailList: [],
            mainTitle: 'firme-zrc',
            updateComponent: null,
            refreshType: RefreshType.Reload,
            loadOnInit: false,            
            breadcrumbLabel: 'FIRMAZRC.PLURAL'
        }
    }




];

const routes: Routes = [    
    {
        path: '',
        component: AdminComponent, 
        children: childrenRoutes
    }

]

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})

export class AdminRoutingModule {}
